<template>
  <div id="app"   >
  <div class="box"  >
  <div class="header" >
          <span class="title-font">{{title}}</span>
  </div>
  <div style="height:10px"></div>
  <div class="xuanze"  >
                  <span style="color: black;margin-left:3%;font-weight: bold;">合同类型：</span>
                  <el-select v-model="form.region" >
                    <el-option label="鞋材购销合同" value="1"></el-option >
                  </el-select>
  </el-form>

  </div>

  <div class="content"  ref="orderForm1"   >
  <div class="agreement-box" >
          <div class="h1"   id="item-list">{{htname}}</div>
          <div >
                <div class="title" id="item-list"  style="height:50px">
                  <div>
                     <el-form label-width="120px" >
                              <el-form-item label="采购方(甲方)：">
                                泉州喜马亚马服饰有限公司
                              </el-form-item>
                      </el-form>
                  </div>
                  <div class="title-right">
                        <el-form  label-width="100px" :model="formLabelAlign">
                              <el-form-item label="合同编号：">
                                <el-input class="inputwidth" v-model="formLabelAlign.name1"></el-input>
                              </el-form-item>
                        </el-form>
                    </div>
                </div>

                <div class="title" id="item-list">

                  <div class="title-right">
                  
                      <el-form label-width="120px" :model="formLabelAlign">
                              <el-form-item label="供货方(乙方)：">
                                <el-input  class="inputwidth" v-model="formLabelAlign.name"></el-input>
                              </el-form-item>
                        </el-form>
                  </div>

                  <div class="title-right">
                    <el-form  label-width="100px" >
                              <el-form-item label="签订地点：">
                                广州市白云区
                              </el-form-item>
                      </el-form>
                  </div>
                  
                </div>

                <p  id="item-list" style="height:30px">
                   协议双方就甲方向乙方购买鞋材之事宜，达成如下条款：
                </p>
                <p id="item-list"  style="height:30px">
                   一、品名、数量、单价、金额
                </p>
                <div    style="min-height:275px">
                  <el-table
                   :data="tableData"
                    id="item-list"
                   border
                  :header-cell-style="{color:'#000000','text-align':'center'}"
                  style="width: 100%; margin-top: 20px; color:black;border:1px solid black; border-right: 1px solid black;">
                  
                  <el-table-column
                   
                    prop="id"
                    label="订单号"
                    min-width="78"
                    >
                     <template slot-scope="scope" id="item-list">
                        <el-input  class="scope-input"  autosize type="textarea" style="width:72px"  @input="handelinput(scope.row.orderID)" v-model="scope.row.orderID"> </el-input>
                        <span class="scope-span">{{scope.row.orderID}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    
                    prop="name"
                    label="公司款号"
                    min-width="78">
                     <template slot-scope="scope" id="item-list">
                      
                        <el-input  class="scope-input"   type="textarea" autosize style="width:72px" @input="handelinput(scope.row.itemNo)" v-model="scope.row.itemNo"></el-input>
                        <span class="scope-span">{{scope.row.itemNo}}</span>
                    </template>
                  </el-table-column>class="scope-input"
                  <el-table-column
                  
                    prop="amount1"
                    label="品名"
                   min-width="95">
                     <template slot-scope="scope" id="item-list">
                        <el-input class="scope-input" autosize type="textarea"  style="width:88px" @input="handelinput(scope.row.commodity)" v-model="scope.row.commodity"></el-input>
                        <span class="scope-span">{{scope.row.commodity}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                  
                    prop="amount2"
                    label="部位"
                   min-width="95">
                     <template slot-scope="scope" id="item-list">
                        <el-input class="scope-input"   autosize type="textarea" style="width:88px" @input="handelinput(scope.row.position)" v-model="scope.row.position"></el-input>
                        <span class="scope-span">{{scope.row.position}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                 
                    prop="amount3"
                    label="宽幅"
                    min-width="64">
                     <template slot-scope="scope"  id="item-list">
                      <el-input class="scope-input"   autosize type="textarea" style="width:57px" @input="handelinput(scope.row.wideinwidth)" v-model="scope.row.wideinwidth"></el-input>
                      <span class="scope-span">{{scope.row.wideinwidth}}</span>
                        <!-- <el-input style="min-width:57px" @input="handelinput(scope.row)" v-model="scope.row.wideinwidth"></el-input> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                  
                    mix-width="64"
                    prop="amount4"
                    label="物性要求/幅宽/克量" >
                     <template slot-scope="scope" id="item-list">
                      <el-input class="scope-input"  autosize  type="textarea" style="width:58px" @input="handelinput(scope.row.require)" v-model="scope.row.require"></el-input>
                      <span class="scope-span">{{scope.row.require}}</span>
                        <!-- <el-input style="width:57px" @input="handelinput(scope.row)" v-model="scope.row.require"></el-input> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                  
                    prop="amount5"
                    label="单位"
                    
                    mix-width="64">
                     <template slot-scope="scope" id="item-list">
                      <el-input class="scope-input" autosize  type="textarea" style="width:58px" @input="handelinput(scope.row.unit)" v-model="scope.row.unit"></el-input>
                      <span class="scope-span">{{scope.row.unit}}</span>
                        <!-- <el-input style="width:57px" @input="handelinput(scope.row)" v-model="scope.row.unit"></el-input> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                  
                    prop="amount6"
                    label="数量"
                    mix-width="68" >
                    <template slot-scope="scope" d="item-list">
                      <el-input class="scope-input" autosize  type="textarea" style="width:69px" @input="handelinput(scope.row.number)" v-model="scope.row.number"></el-input>
                      <span class="scope-span">{{scope.row.number}}</span>
                        <!-- <el-input style="width:57px" @input="handelinput(scope.row)" v-model="scope.row.number"></el-input> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="amount7"
                    label="单价"
                    mix-width="68">
                    <template slot-scope="scope" id="item-list">
                      <el-input class="scope-input" autosize  type="textarea" style="min-width:57px" @input="handelinput(scope.row.price)" v-model="scope.row.price"></el-input>
                      <span class="scope-span">{{scope.row.price}}</span>
                        <!-- <el-input style="width:57px" @input="handelinput(scope.row)" v-model="scope.row.price"></el-input> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    
                    prop="amount8"
                    label="金额"
                    min-width="68">
                     <template slot-scope="scope" id="item-list">
                      <el-input class="scope-input" autosize  type="textarea" style="min-width:57px" @input="handelinput(scope.row.money)" v-model="scope.row.money"></el-input>
                      <span class="scope-span">{{scope.row.money}}</span>
                        <!-- <el-input style="min-width:57px" @input="handelinput(scope.row)" v-model="scope.row.money"></el-input> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="amount9"
                    label="交货日期"
                    min-width="80">
                     <template slot-scope="scope" id="item-list">
                        <!-- <el-input style="width:100px" @input="handelinput(scope.row)" v-model="scope.row.data"></el-input> -->
                        <el-date-picker
                                    v-model="scope.row.data"
                                    align="right"
                                    type="date"
                                    style="width:75px"
                                    >
                                   >
                        </el-date-picker>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="amount10"
                    label="备注"
                    min-width="78">
                     <template slot-scope="scope" id="item-list">
                        <el-input  class="scope-input"  autosize type="textarea" @input="handelinput(scope.row.remarks)" v-model="scope.row.remarks"></el-input>
                        <span class="scope-span">{{scope.row.remarks}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                        v-if="this.isif"
                        label="操作"
                        fixed="right"
                        max-width="40">
                        <template slot-scope="scope">
                          <el-button @click="handleClick(scope.row.id)"  icon="el-icon-plus" type="text" size="small"></el-button>
                          <el-button @click="delectClick(scope.row.id)" icon="el-icon-delete"   type="text" size="small"></el-button>
                        </template>
                    </el-table-column>
                  
                </el-table>
                <div class="biaodnadibu"  style="height:50px" id="item-list">
                  <div style="border-right: 1px solid black;margin-left:10px;">合计金额(大写)：</div>
                  <div>
                    <el-input   style="width:450px;margin-left:10px;"  v-model="remarks"></el-input>
                  </div>
                </div>
              </div>
                
      
               <div class="er"    >
                <p  id="item-list" >二.货款按甲方记录的实际入库量结算，（实际入库量以甲方验收合格的货物的净重/净长度等净数为准 ，不含包装物、码卡等其它重量），乙方交货数量与合同约定数量允许误差±3%，克重允许误差±3%。除本合同明确约定的费用外，甲方无需支付其他任何费用，乙方应支付的违约金、赔偿金等，甲方均有权从未付款中直接扣除。</p> 

                <p  id="item-list">三.产品质量要求及检验标准：甲方提供产品小样，乙方按甲方提供的小样打样，乙方的打样经甲方书面确认后，乙方方可生产大货；大货的质量须与经甲方书面确认的乙方打样完全一致并符合本合同约定及甲方要求， 且不低于国家最新质量标准，以上标准以最高者为准。</p>

                <p  id="item-list">四.产品包装要求：轻质纸管和透明包装袋，码卡用中性标签，每匹材料两头各一张，贴在胶袋上，客户名标注：XMYM，同时必须注明品名，款号，颜色，克重，净重重量，如有不明，提前联系甲方。（若有更高的新国家、行业标准，则按新标准执行包装）包装费由乙方承担，包装物不予回收，因乙方包装不善导致的货物破损、有污渍、丢失等任何损失，均由乙方承担。</p>

                <p   id="item-list">五.运输方式及交货地点：由乙方送货至甲方指定地点，运费、装卸货费、保险费、货物保管及运输风险等均由乙方承担。货物丢失、破损等的，由乙方先行赔付甲方（赔付标准为甲方采购价），后乙方向保险公司索赔，甲方可提供必要协助。货物丢失、破损等给甲方造成损失的，乙方应全额赔偿。</p>

                <p    id="item-list">六.交货时间：乙方须在本合同载明的交货日期前（含当日）将全部货物完好无损送至甲方指定地点 （乙方交货时间以甲方签收时间为准）；乙方如遇洪水、火灾等特殊情况及其它不可抗力事故，应及时书面通知甲方并在不可抗力发生之日起7日内提供当地政府出具的证明，经甲方书面同意后交货期由甲方根据实际情况另行书面确定，乙方在该甲方指定的交货期内交付全部货物的，不视为逾期交货，但甲方拒绝或未作书面同意的，则交货期不予变更。</p>
               </div>
                  <div class="qi-content" id="item-list"  >
                       <div>
                          七.乙方银行账户信息：
                       </div>
                       <div class="qi-xinxi" >
                           <el-form   label-width="120px" :model="formLabelAlign">
                              <el-form-item label="银行账号：" >
                                <el-input class="inputwidth" v-model="formLabelAlign.name3" ></el-input>
                              </el-form-item>
                              <el-form-item label="户名：">
                                <el-input class="inputwidth" v-model="formLabelAlign.region3"></el-input>
                              </el-form-item>
                              <el-form-item label="开户行：">
                                <el-input class="inputwidth" v-model="formLabelAlign.type3"></el-input>
                              </el-form-item>
                            </el-form>

                       </div>
                       
                  </div>


               <p id="item-list"  >八.本合同价款不含税，乙方应在甲方付款前向甲方交付等额合法有效的收据原件，收据须盖乙方公章。若甲方需要乙方开票的，乙方应无条件予以配合，开票产生的税费由甲方承担，甲方承担的税费应不高于票面税费。</p>
               <p id="item-list"  >
                九.结算方式：月结<el-input  class="jiesuan" v-model="formLabelAlign.type1"  ></el-input>天（即甲方签收并验收合格入库后次月起第<el-input  class="jiesuan"  v-model="formLabelAlign.type2"></el-input>个月底前结算，结算数量为甲方签收并验收合格入库的数量。）
               </p >
               <p id="item-list"  >
                十.验收办法和质量异议期限：1.甲方收到货后验收货物质量，验收合格后方视为入库。2.若有质量异议必须在甲方发现之日起15个工作日内通知乙方。3.甲方的验收合格并不免除/减轻乙方对货物的权利瑕疵及质量瑕疵所应承担的全部责任，若甲方/第三方因此受损的乙方须全额赔偿。
               </p>
               <p id="item-list"  >
                十一.违约责任：1．乙方必须按期交货，若乙方延迟交货，每日应按照延迟交货金额的千分之三向甲方支付违约金。2．乙方逾期交货达15日的，甲方有权单方通知解除整个合同或未交货部
                分的订单并不视为违约。3.乙方交付的货物质量不合格，甲方有权拒收并不视为违约。4.乙方交付的货物，甲方签收入库后并不免除乙方对其货物的质量瑕疵担保责任及权利瑕疵担保责任，
                签收入库的货物存在质量问题的，甲方有权退货，因退货产生的费用由乙方承担，且乙方应自甲方通知之日起5日内退还甲方已付的退货部分费用。5.乙方货物违反法律法规或侵犯任何人的
                知识产权或其他合法权益产生的全部责任，均由乙方承担，与甲方无关。
               </p>
               <p id="item-list"  >十二.争议处理：本合同在履行过程中发生的争议，双方协商解决；协商未果，任何一方均可向本合同签订地人民法院提起诉讼。</p>
               <p id="item-list"  >十三.其它约定：本合同内容任何一方不得擅自添加、修改，如经双方确认而添加、修改，需经双方在添加、修改处盖章确认；本合同相关下单明细等可作为合同附件，经甲乙双方盖章确认后与本合同具有同等法律效力; 甲方后期补单，需另签合同。</p>
               <p id="item-list"  > 十四.合同生效：本合同经甲乙双方盖章后生效; 本合同一式贰份，甲乙双方各执壹份，具有同等法律效力。</p>
               <div class="qianshu" id="item-list"  >
                   <div>
                    <el-form  label-width="120px"  :model="formLabelAlignjia">
                      <el-form-item label="甲方：" >
                          <span >泉州喜马亚马服饰有限公司</span>
                        </el-form-item>
                       <el-form-item label="联系地址：">
                          <el-input class="inputwidth" v-model="formLabelAlignjia.jiaaddress"></el-input>
                        </el-form-item>
                        <el-form-item label="业务代表签字：">
                          <el-input class="inputwidth" v-model="formLabelAlignjia.jiadeputy"></el-input>
                        </el-form-item>
                        <el-form-item label="电话/传真：">
                          <el-input class="inputwidth" v-model="formLabelAlignjia.jiaphone"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱：">
                          <el-input class="inputwidth" v-model="formLabelAlignjia.jiapostbox"></el-input>
                        </el-form-item>

                        <el-form-item label="日期：">
                            <div class="block">
                                    <el-date-picker
                                    v-model="formLabelAlignjia.data"
                                    align="right"
                                    type="date"
                                    class="inputwidth"
                                    >
                                  </el-date-picker>
                              </div>
                          </el-form-item>
                      </el-form>
                   </div>
                   <div>
                      <el-form  label-width="120px" :model="formLabelAlignyi">
                        <el-form-item label="乙方：" >
                          <span ><el-input class="inputwidth" v-model="formLabelAlignyi.yi"></el-input></span>
                        </el-form-item>
                        <el-form-item label="联系地址：">
                          <el-input class="inputwidth" v-model="formLabelAlignyi.yiaddress"></el-input>
                        </el-form-item>
                        <el-form-item label="业务代表签字：">
                          <el-input class="inputwidth" v-model="formLabelAlignyi.yideputy"></el-input>
                        </el-form-item>
                        <el-form-item label="电话/传真:">
                          <el-input class="inputwidth" v-model="formLabelAlignyi.yiphone"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱：">
                          <el-input class="inputwidth" v-model="formLabelAlignyi.yipostbox"></el-input>
                        </el-form-item>

                        <el-form-item label="日期：">
                            <div class="block">
                                    <el-date-picker
                                    v-model="formLabelAlignyi.data"
                                    align="right"
                                    type="date"
                                    class="inputwidth"
                                   >
                                  </el-date-picker>
                              </div>
                          </el-form-item>
                      </el-form>
                   </div>
                   
               </div>
               
          </div>
         
     </div>
   
</div>

  <!-- 导出为pdf -->
  <div style="margin-top :30px">
    <div class="pdf">
      <el-button type="primary" @click="pdfDownload" :loading="loading" >生成PDF</el-button>
    </div>
  </div>
  <!-- <canvas id="canvas"></canvas> -->
  <!-- 导出为pdf end-->
</div>

 </div>
</template>
<script>
//引入水印
import watermark from '@/assets/js/index'
//引入vuex 
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
   data(){
    return{
          //var css
          border:'none',
          isshow:'inline-block',
          isshowin:'none',

          htname:'鞋材购销合同',
          input: '',
           agreementlist: {
              age: '',
           },
           tableData: [{
                id: 1,
                name: '',
                amount1: '',
                amount2: '',
                amount3: null,
              }, {
                id: 2,
                name: '',
                amount1: '',
                amount2: '',
                amount3: null,
                quantity:''
              }],
              title:'在线生成PDF合同',
              htid:2,
              formLabelAlign:{},
              shortcuts: [{
                  text: '今天',
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  }
                }],
                value2: '',
                //甲方信息
                formLabelAlignjia:{},
                //乙方方信息
                formLabelAlignyi:{},
                 form: {
                    region: '1',
                  },
                  //大写金额
                  remarks:'',
                  operatorInfo: {
                    
                  },
                  //按钮加载
                  loading:false,
                  //表格操作栏
                  isif:true,
                  time1:'',
                  i: 0
                  
            
    }
   },
   mounted(){
      
        
   },
   computed:{
   },
   methods:{
       //输入框
       handelinput(id){
        id += id + '<br>'

     
      },
       //追加一行
       handleClick(id){
         
         let list = {id:++this.htid}
        for(let i =0; i<this.tableData.length ; i++){
            if(this.tableData[i].id === id){
              this.tableData.splice(i+1,0,list)
            }
        }
       },
       //删除一行
       delectClick(id){
        for(let i =0; i<this.tableData.length ; i++){
            if(this.tableData[i].id === id){
              this.tableData.splice(i,1)
            }
        }
       },
       //生成PDF
     pdfDownload() {
       const _this = this
        _this.$refs.orderForm1.style.setProperty('--boColor',_this.border)
         _this.$refs.orderForm1.style.setProperty('--isshow',_this.isshow)
         _this.$refs.orderForm1.style.setProperty('--isshowin',_this.isshowin)
      //点击隐藏掉表单里面的操作栏 false
       _this.isif = false
      //获取需打印的元素集合
      const children = document.querySelectorAll('#item-list')
       _this.loading = true
       
      //定义装内容的数组 
      let canvas = [] ;
      let i = 0;


      //水印时间  第一进入 时间不变了
      if(_this.i === 0){
          let date = new Date()
      _this.time1 = date.getTime();
        for(let k = 0 ;k< children.length ; k++){
          watermark.set(_this.time1,children[k])
      }
      }
      
        function toCanvas (){  
        if(children.length > 1) {
          
             html2canvas(children[i],{
            dpi:500,
            scale: 4,
            useCORS: true
          }).then(res=>{
            res.imgWidth = 520.28;  //原560 因为
            res.imgHeight = 610.28 / res.width  * res.height
            canvas.push(res)
            i++;
            if(canvas.length === children.length){
              pagin()
              toPdf()
            }else{
              toCanvas()
            }
          })
         
       }
      }
      
      //根据dom高度初步分页 将canvas组装成二维数组
    function pagin() {
        const imgArr = [[]];
        let pageH = 0;// 页面的高度
        let allH = 0;// 当前组所有dom的高度和
        let j = 0;
        for (let k = 0; k < canvas.length; k++) { // 涉及到k--的操作，使用for循环方便
            pageH += canvas[k].imgHeight;
            if (pageH >  821.89 && canvas[k].imgHeight <  821.89) { // 当某个页面装不下下一个dom时，则分页
                imgArr[j][0].allH  = allH  - canvas[k].imgHeight;
                allH = pageH = 0;
                k--;
                j++;
                imgArr.push([]);
            } else {
                if (canvas[k].imgHeight >  821.89) { // 特殊情况：某个dom高度大于了页面高度，特殊处理
                    canvas[k].topH =  821.89 - (pageH - canvas[k].imgHeight);// 该dom顶部距离页面上方的距离
                    pageH = (2 * canvas[k].imgHeight - pageH) %  821.89;
                    canvas[k].pageH = pageH;// 该dom底部距离页面上方的距离
                }
                imgArr[j].push(canvas[k]);
                allH += canvas[k].imgHeight;
            }
            if (k === canvas.length - 1) imgArr[j][0].allH = allH;
        }
        canvas = imgArr;
    }


    function toPdf() {
        const PDF = new JsPDF('', 'pt', 'a4');
        canvas.forEach((page, index) => {
            let allH = page[0].allH;
            let position = 10;// pdf页面偏移
            if (index !== 0 && allH <=  821.89) PDF.addPage();
            page.forEach(img => {
                if (img.imgHeight <  821.89) { // 当某个dom高度小于页面宽度，直接添加图片
                    PDF.addImage(img.toDataURL('image/jpeg', 1.0), 'JPEG', 30, position, img.imgWidth  , img.imgHeight );
                    position += img.imgHeight ;
                    allH -= img.imgHeight ;
                } else { // 当某个dom高度大于页面宽度，则需另行处理
                    while (allH > 0) {
                        PDF.addImage(img.toDataURL('image/jpeg', 1.0), 'JPEG', 30,position , img.imgWidth, img.imgHeight);
                        allH -= img.topH ||  821.89;
                        position -= img.topH ||  821.89;
                        img.topH = 0;
                        if (allH > 0) PDF.addPage();
                    }
                    position = img.pageH;
                }
            });
        });
       
        PDF.save(_this.htname + '.pdf');
        //清楚水印
        _this.time1 = ''
        _this.loading = false 
        let aa = '1px solid black'
        _this.$refs.orderForm1.style.setProperty('--boColor',aa)
        let isshow = 'none'
        //psan标签隐藏
        _this.$refs.orderForm1.style.setProperty('--isshow',isshow)
        //input标签显示
        let isshowin = 'inline-block'
         _this.$refs.orderForm1.style.setProperty('--isshowin',isshowin)
        //pdf下载完显示表单里面的操作栏 true
        _this.isif = true
        //
        _this.i++
       
    }
      toCanvas();
      
        

      //水印
      //   let myBox = this.$refs.orderForm1; //获取ref里面的内容  需要截取内容的容器
         
      //   //修改inpuit的css
      //   //  let str= _this.border.replaceAll("\"", "") 
      //   //  console.log(str);
      //   _this.$refs.orderForm1.style.setProperty('--boColor',_this.border)
      //   //点击隐藏掉表单里面的操作栏 false
      //   _this.isif = false
      //   //获取内容的宽度
      //   let width = myBox.clientWidth 
      //   //获取内容的高度
      //   let height = myBox.clientHeight 
      //   //定义属性

      //   const options = {
      //           logging:true,  // 启用日志，我也不知道怎么看/(ㄒoㄒ)/~~就放着吧
      //           scale: 2,  // 图片渲染的比例，可以用它来调大小
      //           width: width ,  // 保存的图片的宽
      //           height:height ,  // 保存的图片的高
      //           useCORS: true
      //   }
      // // console.log('options',options);
      // //将需要截取的内容传入  还有属性
      // //  html2canvas(myBox, options).then(function(canvas) {
      // //成功的回调
      // //           let baseIm = canvas.toDataURL("image/jpeg")// jpeg格式，也可以保存成png格式
      // //           console.log(baseIm,"base64-Image");
      // //   }).catch(function(error){
      // //           console.log(error,'转码失败')
      // //   });
      //   setTimeout(() => {
      //       html2canvas(myBox, options
      //   // {
      //   //   useCORS: true, //是否尝试使用CORS从服务器加载图像
      //   //   allowTaint: true,
      //   //   dpi: 300, //解决生产图片模糊
      //   //   scale: 3, //清晰度--放大倍数
      //   //   width:width,
      //   //   height:height,
      //   //   backgroundColor:'red',
      //   // }
        
      //   ).then( function (canvas) {
      //     let contentWidth = width
      //     let contentHeight = height 
      //     //内容的高度
      //     let pageHeight = contentWidth  / 592.28 *  821.89 // 一页pdf显示html页面生成的canvas高度;
      //     let leftHeight = contentHeight  //未生成pdf的html页面高度
      //     // console.log('pageHeight',pageHeight);
      //     // console.log('leftHeight',leftHeight);
      //     let position = 0 //pdf页面偏移
      //   //   // //a4纸的尺寸[595.28, 821.89]，html页面生成的canvas在pdf中图片的宽高
      //     let imgWidth = 560.28//宽度
      //     let imgHeight = 592.28 / contentWidth * contentHeight 
      //     console.log('imgHeight A4',imgHeight);
      //     let pageData = canvas.toDataURL('image/jpeg', 1)
      //     let PDF = new JsPDF('', 'pt', 'a4')
      //     // console.log('imgWidth',imgWidth);
      //     // console.log('imgHeight',imgHeight);
      //     // // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度( 821.89)
      //     // //当内容未超过pdf一页显示的范围，无需分页
      //     console.log('leftHeight',leftHeight);
      //     console.log('pageHeight',pageHeight);
      //     if (leftHeight < pageHeight) {
      //       PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
      //     } else {
      //       while (leftHeight > 0) {
        
      //           /// pageDat :图片  jpeg:图片的格式   宽度:在哪个位置开始   postion:从这个高度开始截取   imgWidth -imgHeight : canvas图片的宽度和高度
      //         PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              
      //         leftHeight -= pageHeight
      //         position -=  821.89 
      //         if (leftHeight > 0) {
      //           console.log('添加新的一页');
      //           PDF.addPage()
      //         }
      //       }
      //     }
      //     PDF.save(_this.htname + '.pdf')//下载标题
      //     _this.loading = false 
      //     let aa = '1px solid black'
      //   _this.$refs.orderForm1.style.setProperty('--boColor',aa)
      //   //pdf下载完显示表单里面的操作栏 true
      //   _this.isif = true
      //   });
      //   }, 100);
    },
   },

}

</script>
<style lang="less" scoped>


#app{
  width: 100%;
  height: 100%;
  background: #e2e2e2cc;
}

.h1{
  
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin: 20px 0px;
  
}

.content{
  width: 1046px;
  background: white;
  margin: auto;
  margin-top: 10px;
  
}

// 合同
 .header{
  width:1046px;
  background: white;
  margin: auto;
  border-radius: 5px;
 }
 .title-font{
  font-size: 20px;
  font-weight: 600;
  color: #666;
  position: relative;
  left: 40px;
  line-height: 70px;
 }
 .title-font::before{
  content: "";
  width: 5px;
  height: 30px;
  background: rgb(43, 43, 255);
  position: absolute;
  left: -15px;
  bottom: -3px;
 }
.agreement-box{
 
  background: white;
  width: 95%;
  margin: auto;
  padding-top: 10px;
  
}

//输入框大小:
/deep/ .inputwidth{
  width: 300px !important;
}

.title{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  }
.title-right{
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  }
//填写时显示下划线 

/deep/ .el-textarea__inner{
  border: 0px !important;
  border-bottom: var(--boColor, 1px solid black) ;
  color: black !important;
  padding: 0px !important;

}

/deep/.agreement-box .el-input__inner
{ 
  border: none; 
  border-radius: 0px;
  border-bottom: var(--boColor,1px solid black) ;
  color: black;
  resize: none; 
  padding: 0 ;
  min-height: 28px;
  height: 0px !important; 
  line-height: 0px !important;
  margin-top: 10px !important;
}


//备注 
/deep/.el-textarea__inner {
  overflow-y:hidden !important;
      min-height: 40px !important;
      color: black !important;
      text-align: center !important;
}
// //生成时取消下划线
// /deep/.agreement-box .el-input__innertow
// { 
//   border: none; 
//   border-radius: 0px;
//   // border-bottom: 1px solid black;
//   resize: none; 
// }

/deep/.el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell{
  border: none;
  background-color:white;
}



//第七条
.qi-content{
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  flex-direction: row;

}
.qi-xinxi{
  width: 50%;
 
}
.qianshu{
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
}
.qianshu div:nth-child(1){
  width: 70%;
}
.qianshu div:nth-child(2){
  width: 70%;
}
/deep/.el-icon-date:before{
  content:""
}
p{
  margin-top: 10px;
  min-height: 40px;
}

/deep/.el-form-item__label{
      font-weight: 800;
      color: black;
}
.biaodnadibu{
  height: 50px;
  display: flex;
  border: 1px solid black;
  border-top: none;
}
.biaodnadibu div{
  width: 47%;
  height: 50px;
  line-height: 50px;
}
.box{
  font-size: 14px;
}

//下拉框
.xuanze{
  width: 1046px;
  height: 90px;
  background: white;
  margin: auto;
  display: flex;
  align-items: center;
}
//下拉框
.xuanze-form{
  border: 1px solid red;
  display: flex;
  
}

//pdf下载
.pdf{
  width:1046px;
  height: 80px;
  margin:auto;
  background: white;
  text-align: center;
  line-height: 80px;
}

//边框颜色:

/deep/ .el-table th {
    border-bottom: 1px solid black !important;
    border-right: 1px solid black !important;
}

/deep/ .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid black !important;
    border-right: 1px solid black !important;
}

//输入框离表格的边距
/deep/.el-table .cell{
  padding-left: 3px !important;
  padding-right: 3px !important;
}

//第九 结算方式的输入框
.jiesuan{
    width:40px ;
    padding:0px 20px ;
    text-align: center !important; 
    border: none;
}


//  class=inputwidth 输入框间隔
/deep/.el-form-item{
      margin-bottom: 0px !important;
}

//水印

  //el inpit type 
  /deep/.el-textarea__inner{
    word-wrap: break-word;
    word-break: normal;
  }

  //表格中的span
  .scope-span{
    display: var(--isshow,none);
    
  }
  //表格中的input
  /deep/.scope-input{
    //禁止出现滚动条 显示全部内容
    overflow-y:hidden !important; 
    min-height: 30px !important;
    display: var(--isshowin,inline-block) !important;
  }
</style>



